import type { GetterTree } from 'vuex';
import {
  GET_DATASPACE_CONNECTOR,
  GET_DATASPACES,
  GET_MY_DATASPACES,
  GET_MY_SELECTED_DATASPACE,
  GET_SELECTED_DATASPACE,
  IS_LOADING,
} from './getter-types';
import type { IntDataspaceState } from './IntDataspaces';

export const getters: GetterTree<IntDataspaceState, {}> = {
  [GET_DATASPACES]: (state) => state.dataspaces,
  [IS_LOADING]: (state) => state.isLoading,
  [GET_SELECTED_DATASPACE]: (state) => state.selectedDataspace,
  [GET_MY_DATASPACES]: (state) => state.myDataspaces,
  [GET_MY_SELECTED_DATASPACE]: (state) => state.mySelectedDataspace,
  [GET_DATASPACE_CONNECTOR]: (state) => state.dataspaceConnector,
};
